import { render, staticRenderFns } from "./RelatedArticles.vue?vue&type=template&id=2bd92d1b&scoped=true&"
import script from "./RelatedArticles.vue?vue&type=script&lang=js&"
export * from "./RelatedArticles.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticles.vue?vue&type=style&index=0&id=2bd92d1b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd92d1b",
  null
  
)

export default component.exports